import { avisData } from '../../../mocks/avis';

export default function Avis() {
  const handleGoogleReviews = () => {
    window.open('https://www.google.com/maps/place/KE\'IKI/@-17.4820574,-149.8042624,17z/data=!4m8!3m7!1s0x769a213d903d2465:0x9c417725d087bdb8!8m2!3d-17.4820625!4d-149.8016875!9m1!1b1!16s%2Fg%2F11r8fr8g7d?entry=ttu&g_ep=EgoyMDI2MDIxOC4wIKXMDSoASAFQAw%3D%3D', '_blank');
  };

  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/20 via-stone-50 to-emerald-50/40"></div>
      
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl font-serif text-gray-900 mb-4">
            Avis de nos Clients
          </h2>
          <p className="text-xl text-gray-600 font-light mb-6">
            Votre satisfaction est notre priorité
          </p>
          
          {/* Rating Summary */}
          <div className="flex items-center justify-center gap-2 mb-4">
            {[1, 2, 3, 4, 5].map((star) => (
              <i key={star} className="ri-star-fill text-3xl text-yellow-500"></i>
            ))}
          </div>
          <p className="text-lg text-gray-600">
            4.8/5 sur Google • Plus de 150 avis
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {avisData.map((avis, index) => (
            <div
              key={index}
              className="bg-white/70 backdrop-blur-lg border border-gray-200/60 rounded-3xl p-8 hover:shadow-xl transition-all duration-300"
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i
                    key={star}
                    className={`${
                      star <= avis.rating ? 'ri-star-fill text-yellow-500' : 'ri-star-line text-gray-300'
                    } text-lg`}
                  ></i>
                ))}
              </div>

              {/* Review */}
              <p className="text-gray-700 mb-6 leading-relaxed">
                "{avis.comment}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-full text-emerald-700 font-semibold text-lg">
                  {avis.author.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-gray-900">{avis.author}</p>
                  <p className="text-sm text-gray-500">{avis.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button
            onClick={handleGoogleReviews}
            className="inline-flex items-center gap-3 px-8 py-4 bg-emerald-600 hover:bg-emerald-700 text-white text-lg font-medium rounded-full shadow-lg hover:shadow-xl transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-google-line text-xl"></i>
            Voir tous les avis sur Google
          </button>
        </div>
      </div>
    </section>
  );
}